<template>
  <transition leave-active-class="animated zoomOut">
    <li :key="payload.id" class="proposal" :class="'proposal-' + payload.status">
      <div class="proposal-deets">
        <ul class="proposal-actions">
          <li class="watch" title="Watch"><a @click="toggleWatch()"><i class="fa" :class="{ 'fa-eye': !isWatched, 'fa-eye-slash': isWatched }"></i></a></li>
          <li class="analytics" title="Document Analytics" v-if="payload.status !== 'draft'">
            <router-link :to="'/a/document/' + payload.id + '/analytics'"><i class="icon icon-analytics"></i></router-link>
          </li>
          <li class="chat" title="Document Comments">
            <router-link :to="'/a/document/' + payload.id + '/comments'"><i class="icon icon-chat"></i></router-link>
          </li>
          <li class="edit" title="Edit Document">
            <router-link :to="'/a/document/' + payload.id"><i class="icon icon-edit"></i></router-link>
          </li>
          <li class="copy" title="Make a Copy">
            <a @click="copyDocument"><i class="icon icon-doc-copy"></i></a>
          </li>
          <li title="Delete Document"><span><i class="icon icon-trash" @click="deletePayload()"></i></span></li>
        </ul>
        <span class="status">
          <router-link :to="'/a/document/' + payload.id + '/comments'">
            <span class="comments">{{ payload.comments.length > 0 ? payload.comments.length : '0' }}</span>
        </router-link>
        {{ $t('proposals.status_types.' + payload.status) }}
        </span>
        <span class="proposal-title">
          <router-link :to="'/a/document/' + payload.id" v-if="payload.status === 'draft'">{{ payload.title }}</router-link>
          <router-link :to="'/a/document/' + payload.id + '/preview'" v-if="payload.status !== 'draft'">{{ payload.title }}</router-link>
        </span>
        <span class="proposal-card-bottom">
          <ul class="proposal-team">
            <li v-for="commenter in limit(commenters, 0, 5)" :key="commenter.id">
              <team-member-avatar :subject="commenter" height="45px" width="45px"></team-member-avatar>
            </li>
            <li v-if="commenters && commenters.length >= 6">
              <link-popover>
                <div class="more-team-members"><i class="icon icon-more"></i></div>
                <div slot="content">
                  <div v-for="commenter in limit(commenters, 5)" :class="{ 'active': commenter.isActive }" :key="commenter.id"><span class="activity-indicator"></span> {{ commenter.name }}</div>
                </div>
              </link-popover>
            </li>
          </ul>
          <span class="proposal-created">{{ $t('proposals.created_by') }} {{ payload.user.name }} {{ payload.created_at | utcFromNow }}</span>
        </span>
      </div>
    </li>
  </transition>
</template>

<script>
import DocumentLists from 'mixins/document-lists';

export default {
  mixins: [DocumentLists],
}
</script>

<style lang="scss" scoped>
@import "resources/assets/sass/layout/_variables";
.activity-indicator {
  display: inline-block;
  position: relative;
  width: 10px;
  height: 10px;
  background-color: $lightergrey;
  border-radius: 50%;
  border: 1px solid $white;
  z-index: 1;
}

.active {
  .activity-indicator {
    background-color: $green;
  }
}

ul.proposal-team {
  display: flex;
  flex-wrap: wrap;
}

li.proposal {
  width: 25%;
  margin-bottom: 30px;
  position: relative;
  .proposal-deets {
    border: 1px solid $white;
    background: $white;
    box-shadow: 0 2px 13px 1px rgba(211, 215, 221, 0.50);
    border-radius: 5px;
    margin: 0 26px 20px 0;
    min-height: 226px;
    position: relative;
    -webkit-transition: all .2s ease;
    -moz-transition: all .2s ease;
    -o-transition: all .2s ease;
    transition: all .2s ease;
    .status {
      text-transform: uppercase;
      font-size: 12px;
      letter-spacing: 1px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      padding: 7px 0 0 42px;
      font-weight: 600;
      .comments {
        width: 30px;
        height: 30px;
        display: block;
        margin-right: 10px;
        color: $white;
        text-align: center;
        font-weight: 700;
        font-size: 13px;
        position: absolute;
        top: -1px;
        left: -1px;
        border-radius: 5px 0 10px;
        padding-top: 6px;
        padding-left: 1px;
      }
    }
    .proposal-title {
      display: block;
      font-size: 18px;
      font-weight: 500;
      margin-top: 40px;
      padding: 0 15px 0 15px;
      width: 100%;
      a {
        color: $grey;
        &:hover {
          color: $green;
        }
      }
    }
    .proposal-client {
      display: block;
      width: 100%;
      font-weight: 700;
      padding: 0 15px 20px;
      font-size: 12px;
      a {
        color: $grey;
        &:hover {
          cursor: pointer;
        }
      }
    }
    .proposal-card-bottom {
      display: flex;
      align-items: flex-end;
      width: 100%;
      flex-direction: column;
      position: absolute;
      bottom: 0;
      ul.proposal-team {
        padding: 0 15px 0 24px;
        width: 100%;
        margin-bottom: auto;
        li {
          margin-left: -9px;
        }
      }
      .proposal-created {
        width: 100%;
        margin-bottom: auto;
        display: block;
        font-size: 11px;
        font-color: $lightgrey;
        padding: 10px 15px 15px;
      }
    }
    ul.proposal-actions {
      display: flex;
      color: $grey;
      margin: 0 auto;
      overflow: hidden;
      text-align: center;
      font-size: 18px;
      justify-content: center;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      opacity: 0;
      -webkit-transition: all .3s ease;
      -moz-transition: all .3s ease;
      -ms-transition: all .3s ease;
      -o-transition: all .3s ease;
      transition: all .3s ease;
      li {
        background: $white;
        border: 1px solid lighten($mutedblue, 16%);
        border-right: none;
        a,
        span {
          padding: 5px 10px 2px;
          display: inline-block;
          -webkit-transition: all .3s ease;
          -moz-transition: all .3s ease;
          -ms-transition: all .3s ease;
          -o-transition: all .3s ease;
          transition: all .3s ease;
          i {
            color: $mutedblue;
          }
          span {
            &.analytics {
              i {
                margin-right: 2px;
              }
            }
            i {
              &:hover {
                color: $green;
                cursor: pointer;
              }
            }
          }
        }
        &:first-child {
          border-top-left-radius: 52px;
          border-bottom-left-radius: 52px;
          a,
          span {}
        }
        &:last-child {
          border-top-right-radius: 52px;
          border-bottom-right-radius: 52px;
          border-right: 1px solid lighten($mutedblue, 16%);
          a,
          span {
            border-right: none;
            padding-left: 7px;
            padding-right: 14px;
          }
        }
        &:hover {
          background: $green;
          color: $white;
          cursor: pointer;
          span {
            &:hover {
              color: $white;
            }
          }
          a {
            &:hover {
              color: $white;
            }
          }
          i {
            color: $white;
            &:hover {
              color: $white;
            }
          }
        }
        &.watch {
          a {
            line-height: 0.7;
            font-size: 19px;
          }
        }
        &.edit,
        &.copy {
          a,
          span {
            padding-left: 9px;
            padding-right: 11px;
            i {
              margin-top: 1px;
            }
          }
        }
        &.chat {
          a,
          span {
            i {
              margin-top: 1px;
            }
          }
        }
      }
    }
  }
  &:hover {
    .proposal-deets {
      .proposal-actions {
        bottom: -43px;
        opacity: 1;
      }
    }
  }
  &:nth-child(4n+4) {
    .proposal-deets {
      margin-right: 0;
    }
    .actions {
      padding-right: 0;
    }
  }
  &.proposal-draft {
    .proposal-deets {
      .status {
        color: $yellow;
        .comments {
          background-color: $yellow;
        }
      }
      .proposal-title {
        a {
          &:hover {
            color: $yellow;
          }
        }
      }
      ul.proposal-actions {
        li {
          &:hover {
            background: $yellow;
          }
        }
      }
    }
    &:hover {
      .proposal-deets {
        border-color: $yellow;
      }
    }
  }
  &.proposal-sent {
    .proposal-deets {
      .status {
        color: $mutedblue;
        .comments {
          background-color: $mutedblue;
        }
      }
      .proposal-title {
        a {
          &:hover {
            color: $mutedblue;
          }
        }
      }
      ul.proposal-actions {
        li {
          &:hover {
            background: $mutedblue;
          }
        }
      }
    }
    &:hover {
      .proposal-deets {
        border-color: $mutedblue;
      }
    }
  }
  &.proposal-viewed {
    .proposal-deets {
      .status {
        color: $purple;
        .comments {
          background-color: $purple;
        }
      }
      .proposal-title {
        a {
          &:hover {
            color: $purple;
          }
        }
      }
      ul.proposal-actions {
        li {
          &:hover {
            background: $purple;
          }
        }
      }
    }
    &:hover {
      .proposal-deets {
        border-color: $purple;
      }
    }
  }
  &.proposal-pending {
    .proposal-deets {
      .status {
        color: $blue;
        .comments {
          background-color: $blue;
        }
      }
      .proposal-title {
        a {
          &:hover {
            color: $blue;
          }
        }
      }
      ul.proposal-actions {
        li {
          &:hover {
            background: $blue;
          }
        }
      }
    }
    &:hover {
      .proposal-deets {
        border-color: $blue;
      }
    }
  }
  &.proposal-signed {
    .proposal-deets {
      .status {
        color: $green;
        .comments {
          background-color: $green;
        }
      }
      .proposal-title {
        a {
          &:hover {
            color: $green;
          }
        }
      }
      ul.proposal-actions {
        li {
          &:hover {
            background: $green;
          }
        }
      }
    }
    &:hover {
      .proposal-deets {
        border-color: $green;
      }
    }
  }
  .more-team-members {
    background: darken($grey, 10%);
    border-radius: 50%;
    width: 45px;
    height: 45px;
    color: $white;
    border: 1px solid $white;
    text-align: center;
    padding-top: 9px;
  }
}
</style>



// WEBPACK FOOTER //
// document-card.vue?b39328d4